
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import JrSelect from '@/components/jr-parts/JrSelect.vue'
import { IntegerCodeNameResponse } from '@/api'
import { ReadRequest } from '@/requests/constructionType'

export default defineComponent({
  name: 'ConstructionTypeSelect',
  components: {
    JrSelect,
  },
  emits: ['update:modelValue', 'update:name'],
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    blank: {
      type: Boolean,
      required: false,
      default: true,
    },
    popperAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  async setup(props, context) {
    const constructionTypes: Array<IntegerCodeNameResponse> = []

    if (props.blank) {
      // 空白の選択肢を付与する
      constructionTypes.push({
        code: -1,
        name: ' ',
      })
    }

    // 工事種別一覧の取得
    const request = new ReadRequest()
    await request.exec()
    if (request.success) {
      const { data } = request.getResponse() as AxiosResponse<Array<IntegerCodeNameResponse>>
      constructionTypes.push(...data)
    }

    return {
      constructionTypes,
      update: (value: string) => {
        // 選択したvalueを返す
        context.emit('update:modelValue', value)
      },
      updateName: (name: string | null) => {
        // 選択したnameを返す
        context.emit('update:name', name)
      },
    }
  },
})
